import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-common-error',
  templateUrl: './common-error.component.html',
  styleUrls: ['./common-error.component.css']
})
export class CommonErrorComponent implements OnInit {

  @Input() appName = "" ;
  @Input() startPage = "" ;
  errormsg = ""
  constructor() { }

  ngOnInit(): void {
    this.errormsg = "Your session has timed out due to inactivity and no information has been submitted as a result."
  }

}
